
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ImageV, Media } from "@/types/media";
import Icon from "@/components/UI/Icon.vue";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";
@Component({
  components: { Icon }
})
export default class MediaPreview extends Vue {
  @Prop()
  value?: Media;

  @Prop({ default: false })
  small!: boolean;

  get image() {
    return pipe(
      this.value,
      ImageV.decode,
      fold(
        () => null,
        validImage => validImage
      )
    );
  }

  get imageUrl() {
    return this.image?.sizes.large?.url || this.value?.url;
  }

  get imageTooSmall() {
    if (!this.image) return false;
    return this.image.sizes.full.height <= 200;
  }
}
